export default __webpack_public_path__ + "static/media/configure-image.72c77e0a.png";